import $ from 'jquery';
import Pikaday from 'pikaday';
import 'pikaday/css/pikaday.css';   // Import missing styles

export default () => {
    $('.datepicker').each(function(k, v) {
        let defaults = {},
            options = {
                field : v,
                format: 'ddd MMM DD YYYY'
            },
            picker = new Pikaday($.extend(defaults, options));
    });
}
